module.exports = __webpack_public_path__ + "static/pot-spoon-c46bc9a13951530be27aa7b8c9848cbc.svg";